<div *ngFor="let element of list" [class.push]="isPush" [class.border-btm]="withBorder" [class.disabled]="isDisabled">
	<app-icon
		*ngIf="element[0] !== value"
		(click)="isChange ? checkItem(element[0]) : null"
		[class.cursor-none]="!isChange"
		[class.isActive]="isActive"
		>
		{{ iconName.uncheckedIconName }}
	</app-icon>
	<app-icon
		*ngIf="element[0] === value"
		(click)="isChange ? checkItem(element[0]) : null"
		[class.cursor-none]="!isChange"
		[class.isActive]="isActive"
		[class.checked]="withBorder"
		>
		{{ iconName.checkedIconName }}
	</app-icon>
	<label [class.isActive]="isActive" pTooltip="{{ tooltipText }}">{{ element[1] }}</label>
</div>
